import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DEALS_GATEWAY, DealsGateway } from '@prlw/core/deals/deals.gateway';
import { lastDealsTableColumns } from '@prlw/core/deals/data/last-deals.data';
import { LastDealsTableColumn } from '@prlw/core/deals/types/last-deals.types';

@Injectable({
  providedIn: 'root',
})
export class LastDealsProvider {
  private readonly _columns$ = new BehaviorSubject<LastDealsTableColumn[]>(
    lastDealsTableColumns,
  );

  constructor(@Inject(DEALS_GATEWAY) private readonly gateway: DealsGateway) {}

  public get columns$(): Observable<LastDealsTableColumn[]> {
    return this._columns$.asObservable();
  }

  public getDealsByInstrument(
    instrumentCode: string,
    lastDealTimestamp: string,
  ) {
    return this.gateway.getDealsByInstrument(instrumentCode, lastDealTimestamp);
  }

  public get gridSize$(): Observable<string> {
    return this.columns$.pipe(
      map((col) =>
        col
          .map((x, i) => {
            const min = x.cellSizeMin;
            const max =
              i === col.length - 1 ? (x.cellSizeMax ?? x.cellSizeMin) : '1fr';
            return `minmax(${min ?? 0}, ${max ?? 0})`;
          })
          .join(' '),
      ),
    );
  }
}
